import React, { ReactNode } from 'react'
import { Dialog, DialogProps, styled } from '@mui/material'
import CustomModalHeader from './CustomModalHeader'
import styles from './CustomModal.module.scss'
import CustomModalFooter from './CustomModalFooter'

interface CustomModalProps {
  isVisible: boolean
  title: string | undefined
  children: ReactNode
  closeModal: () => void
  maxWidth?: DialogProps['maxWidth']
  footerConfig?: any // Replace 'any' with the actual type of footerConfig if available
  leftIcon?: ReactNode
  disableEnforceFocus?: boolean
}

const CustomModal: React.FC<CustomModalProps> = ({
  isVisible,
  title,
  children,
  closeModal,
  maxWidth = 'md',
  footerConfig,
  leftIcon,
  disableEnforceFocus,
}) => {
  const StyledDialog = styled(Dialog)`
    & .MuiPaper-root {
      border-radius: 16px;
    }
  `

  return (
    <StyledDialog
      open={isVisible}
      fullWidth
      maxWidth={maxWidth}
      {...(disableEnforceFocus && { disableEnforceFocus: true })}
    >
      <div className={styles.container}>
        <CustomModalHeader title={title} onClick={closeModal} leftIcon={leftIcon} />
        <div className={styles.mainContainer}>{children}</div>
        {footerConfig && <CustomModalFooter config={footerConfig} />}
      </div>
    </StyledDialog>
  )
}

export default CustomModal
